<template>
  <div>
    <div class="section">
      <div class="container section__content">
        <h2 class="std__subtile">{{$t("astrology")}} 
          <!-- <span v-if="language ==='english'">{{elements.element_name}}</span> -->
          <span>{{ element_translate[`${language}`] }}</span>
           {{$t("element")}}</h2>
        <p class="std__subtile yellow lg">{{$t("elem")}} 
          <span>{{ element_translate[`${language}`] }}</span>
        </p>
        <div class="row">
          <div class="col-md-8 order-2 order-md-1 m2--topBtm">
            <ul class="nav nav-tabs custom" id="elementsInfo" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="description-tab"
                  data-toggle="tab"
                  href="#description"
                  role="tab"
                  aria-controls="description"
                  aria-selected="false"
                >{{$t("description")}}</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="ascendant-tab"
                  data-toggle="tab"
                  href="#ascendant"
                  role="tab"
                  aria-controls="ascendant"
                  aria-selected="true"
                >{{$t("ascendant")}}</a>
              </li>
            </ul>
            <div class="tab-content" id="elementsInfo">
              <div
                class="tab-pane fade show active"
                id="description"
                role="tabpanel"
                aria-labelledby="description-tab"
              >
              <span v-if="language==='english'">
                <p
                  class="std__txt"
                  v-for="element in elements.description"
                  :key="element.key"
                >{{element.trim()}}</p>
              </span>
              <span v-if="language!=='english'">
                <p
                  class="std__txt"
                  v-for="element in desc"
                  :key="element.key"
                >{{element.trim()}}</p>
              </span>
              </div>
              <div
                class="tab-pane fade"
                id="ascendant"
                role="tabpanel"
                aria-labelledby="ascendant-tab"
              >
              <span v-if="language==='english'">
                <p
                  class="std__txt"
                  v-for="element in elements.element_ascendant"
                  :key="element.key"
                >{{element.trim()}}</p>
              </span>
             
              <span v-if="language!=='english'">
                <p
                  class="std__txt"
                  v-for="element in ascen"
                  :key="element.key"
                >{{element.trim()}}</p>
              </span>
              </div>
            </div>
          </div>
          <div class="col-md-4 order-1 order-md-2 m2--topBtm">
            <div class="imagePlaceholder elem">
              <img class="elem_icon" :src="elements.elem_icon" :alt="elements.element_name" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="std__subtile md">{{$t("related")}}</p>
            <div class="rowContent">
              <div class="inlineTags" v-for="element in elements.relate_icon" :key="element.key">
                <router-link
                  :to="{ name: 'ZodiacDetails', params: { zodiac:  element[1].toLowerCase()} }"
                >
                  <img class="elem_icon" :src="element[0]" alt />
                  <p class="traits">{{element[1]}}</p>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters,mapActions } from "vuex";
const proxyurl = "https://cors-anywhere.herokuapp.com/";
const URL = "https://zodiacal.herokuapp.com/elements/";
var TJO = require("translate-json-object")();

export default {
  data() {
    return {
      elements: {},
      element: this.$route.params.element,
      element_translate: [],
      desc: {},
      ascen: {}
    };
  },
  computed: mapGetters(["language", "countryCode", "translateCode"]),
  mounted() {
    this.getZodiacSign();
  },
  methods: {
    getZodiacSign() {
      let related_icon = [];
      const element = {
        url: proxyurl + URL + this.element,
        method: 'GET'
      }
      this.$axios(element).then((res) => {
        this.loading = false
        let elem = res.data[0];

          elem.elem_icon = require(`../../assets/mobiscope/imgs/elements/${this.element}.svg`);
          for (let i = 0; i < elem.element_contents.length; i++) {
            //put image on each horoscope sign
            let str = elem.element_contents[i];
            //trim blank space
            let element_name = str.trim();
            related_icon[i] = [
              require(`../../assets/mobiscope/imgs/horoscope_icon/${element_name}.svg`),
              `${element_name}`
            ];
          }
          this.element_translate['english'] = this.element
          elem.relate_icon = related_icon;
          this.elements = elem;

          this.translate(this.elements)
      })
      .catch((err) => {
        console.error(err);
      })
    },
    translate(elements){
      //translate
      let elem = elements.element_name.toLowerCase()
      let i18n = this.$i18n._vm.messages

      for (let [key, value] of Object.entries(i18n)) {
        if(key=="arabic"){
          this.element_translate['arabic'] = value[elem]
        }
        if(key=="greek"){
          this.element_translate['greek'] = value[elem]
        }
        if(key=="malay"){
          this.element_translate['malay'] = value[elem]
        }
        if(key=="thai"){
          this.element_translate['thai'] = value[elem]
        }
      }
      
      TJO.init({
        // googleApiKey: 'AIzaSyBm4nfZjFUrt4A6MKWxHxCKIT3L4h8VPH8',
        googleApiKey: 'AIzaSyCq1acQaQt46Yx2VK1BrlYm19SN7hqbf04',
        // yandexApiKey: "trnsl.1.1.20191111T072241Z.a4ad72c3f47a325f.7a1d4907e47128f839d39d2241ed3fcc0414ada7"
      });

      var translate = {
        desc: elements.description.join("/"),
        asce: elements.element_ascendant.join("/"),
      };

      if(this.translateCode != ""){
        TJO.translate(translate, this.translateCode).then((data) => {
          this.desc = data.desc.split("/")
          this.ascen = data.asce.split("/")
        })
      }
    }
  }
};
</script>

<style  lang="scss">
.imagePlaceholder.elem {
  text-align: center;
  .elem_icon {
    width: 110px;
    height: 110px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobiscope/ElementsDetails.vue